import { useState } from "react";
import { toast } from "sonner";

export const RFTComingSoon = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNotify = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      toast.success("We'll notify you when the first talk drops.");
      e.target.reset();
    }, 1000);
  };

  return (
    <section
      id="rft"
      data-testid="rft-section"
      className="relative bg-[#050505] px-6 md:px-10 lg:px-16 py-20 md:py-28"
    >
      <div className="flex items-end justify-between mb-12 md:mb-16 border-b border-white/10 pb-6 flex-wrap gap-4">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-flare mb-3">
            /04 — real founder talks
          </p>
          <h2 className="font-display font-extrabold text-4xl md:text-6xl uppercase tracking-tighter leading-[0.95]">
            The raw <span className="italic font-normal text-flare">tapes</span>
            .
          </h2>
        </div>
      </div>

      <div className="relative border border-flare/30 bg-[#0A0A0A] p-8 md:p-16 flex flex-col items-center text-center overflow-hidden">
        {/* Grain overlay */}
        <div className="absolute inset-0 pointer-events-none opacity-20 grain" />

        <div className="relative z-10 max-w-2xl">
          <p className="font-mono text-xs uppercase tracking-[0.4em] text-flare mb-6">
            // STATUS: RECORDING IN PROGRESS
          </p>
          <h3 className="font-display font-extrabold text-3xl md:text-5xl uppercase tracking-tighter mb-6 leading-tight text-bone">
            Real conversations with NCR builders. <br /> No scripts. No filters.
          </h3>
          <p className="text-bone-muted text-base md:text-lg mb-12 max-w-lg mx-auto leading-relaxed">
            We're currently editing the first batch of talks. Drop your email to
            be the first to watch when the vault opens.
          </p>

          <form
            onSubmit={handleNotify}
            className="flex flex-col md:flex-row gap-3 max-w-md mx-auto w-full"
          >
            <input
              required
              type="email"
              placeholder="Email address"
              className="flex-1 bg-black/50 border border-white/10 px-4 py-3 text-bone font-mono text-sm focus:outline-none focus:border-flare transition-colors"
            />
            <button
              disabled={isSubmitting}
              type="submit"
              className="bg-flare text-black px-8 py-3 font-mono text-xs uppercase tracking-[0.2em] hover:bg-bone transition-colors disabled:opacity-50"
            >
              {isSubmitting ? "WAIT..." : "NOTIFY ME"}
            </button>
          </form>
        </div>

        {/* Decorative elements */}
        <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-flare/10 rounded-full blur-[100px] pointer-events-none" />
        <div className="absolute -top-24 -left-24 w-64 h-64 bg-flare/5 rounded-full blur-[100px] pointer-events-none" />
      </div>
    </section>
  );
};
